import { takeEvery } from 'redux-saga/effects';
import { load } from 'sdk/billerAddress';
import { LOAD } from 'model/billerAddress';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({ api: load, dataName: ORM, type: LOAD })
  );
}
